import * as React from 'react';

import * as styles from './ChatList.css';
import { ERequestApiStatus } from '../../types/appState';
import { ScrollableBlock } from '../ScrollableBlock';

// Высота элемента списка чатов
const CHAT_ITEM_HEIGHT = 124;

interface IChatListProps {
  getNextPage(): void;
  status: ERequestApiStatus;
  allChatsLoaded?: boolean;
  listRef?: React.RefObject<HTMLDivElement>;
  children: React.ReactNode;
}

export const ChatList: React.FC<IChatListProps> = ({ getNextPage, status, allChatsLoaded, listRef, children }) => {
  const onPageScroll = React.useCallback(() => {
    if (allChatsLoaded || status === ERequestApiStatus.Pending) {
      return;
    }

    getNextPage();
  }, [allChatsLoaded, status, getNextPage]);

  return (
    <div className={styles['container']}>
      <div ref={listRef} className={styles['list-container']}>
        {status === ERequestApiStatus.Pending && <div className={styles['overlay']} />}
        <div className={styles['inner-container']}>
          <ScrollableBlock onPageScroll={onPageScroll} itemHeight={CHAT_ITEM_HEIGHT}>
            {children}
          </ScrollableBlock>
        </div>
      </div>
    </div>
  );
};
